/* Inner Compass — AI, welzijn en veiligheid.
 * Dutch authoritative; English faithful translation. */

export const aiSafetyContent = {
  nl: [
    {
      body: "Inner Compass is ontworpen om mensen te ondersteunen bij reflectie en mentaal welzijn.",
    },
    {
      heading: "Inner Compass is geen zorgverlener",
      body: [
        "Inner Compass is geen arts, psycholoog, psychotherapeut, psychiater, medische instelling of noodhulpdienst.",
        "Inner Compass stelt geen medische diagnose en biedt geen medische behandeling.",
        "De Dienst is niet bedoeld als vervanging voor professionele medische, psychologische of psychiatrische zorg.",
      ],
    },
    {
      heading: "AI kan fouten maken",
      body: ["Inner Compass gebruikt kunstmatige intelligentie.", "AI-reacties kunnen:"],
      list: [
        "onjuist zijn;",
        "onvolledig zijn;",
        "belangrijke informatie missen;",
        "context verkeerd begrijpen;",
        "niet geschikt zijn voor jouw persoonlijke situatie.",
      ],
      note: "Gebruik AI-informatie daarom niet als enige basis voor belangrijke gezondheids-, veiligheids- of levensbeslissingen.",
    },
    {
      heading: "Persoonlijke inzichten",
      body: [
        "Scores, patronen, samenvattingen, herinneringen, reflecties en andere persoonlijke inzichten binnen Inner Compass zijn ondersteunende hulpmiddelen.",
        "Ze vormen geen medische diagnose of professioneel klinisch oordeel.",
      ],
    },
    {
      heading: "Veiligheids- en crisisdetectie",
      body: [
        "Inner Compass kan bepaalde berichten automatisch analyseren om taal te herkennen die mogelijk wijst op een crisis of veiligheidsrisico.",
        "Deze systemen zijn bedoeld om passende hulpinformatie te kunnen tonen, maar zijn niet foutloos.",
        "Inner Compass kan niet garanderen dat ieder crisissignaal wordt herkend.",
        "De Dienst wordt niet continu door een menselijke hulpverlener gemonitord en is geen noodmeldsysteem.",
      ],
    },
    {
      heading: "Bij acuut gevaar",
      body: ["Als jij of iemand anders in onmiddellijk gevaar verkeert, gebruik Inner Compass dan niet als vervanging voor directe hulp.", "In Nederland:"],
      list: [
        "Acuut gevaar: 112",
        "Gedachten aan zelfdoding of behoefte aan hulp rondom suïcidaliteit: 113 Zelfmoordpreventie",
      ],
      note: "Voor gebruikers buiten Nederland: neem contact op met de lokale hulpdiensten of een lokale crisisdienst.",
    },
    {
      heading: "Professionele hulp",
      body: [
        "Wanneer je vragen hebt over een medische of psychische aandoening, behandeling of medicatie, neem dan contact op met een gekwalificeerde zorgprofessional.",
        "Inner Compass kan aanvullende ondersteuning bieden, maar vervangt deze professional niet.",
      ],
    },
  ],
  en: [
    { body: "Inner Compass is designed to support people with reflection and mental wellbeing." },
    {
      heading: "Inner Compass is not a healthcare provider",
      body: [
        "Inner Compass is not a doctor, psychologist, psychotherapist, psychiatrist, medical institution or emergency service.",
        "Inner Compass does not provide a medical diagnosis and does not provide medical treatment.",
        "The Service is not intended as a replacement for professional medical, psychological or psychiatric care.",
      ],
    },
    {
      heading: "AI can make mistakes",
      body: ["Inner Compass uses artificial intelligence.", "AI replies can:"],
      list: ["be inaccurate;", "be incomplete;", "miss important information;", "misunderstand context;", "not be suitable for your personal situation."],
      note: "For this reason, do not use AI information as the sole basis for important health, safety or life decisions.",
    },
    {
      heading: "Personal insights",
      body: [
        "Scores, patterns, summaries, memories, reflections and other personal insights within Inner Compass are supporting tools.",
        "They do not constitute a medical diagnosis or professional clinical judgement.",
      ],
    },
    {
      heading: "Safety and crisis detection",
      body: [
        "Inner Compass may automatically analyse certain messages to recognise language that may indicate a crisis or safety risk.",
        "These systems are intended to be able to show appropriate help information but are not error-free.",
        "Inner Compass cannot guarantee that every crisis signal is recognised.",
        "The Service is not continuously monitored by a human responder and is not an emergency reporting system.",
      ],
    },
    {
      heading: "In case of acute danger",
      body: ["If you or someone else is in immediate danger, do not use Inner Compass as a replacement for direct help.", "In the Netherlands:"],
      list: [
        "Acute danger: 112",
        "Thoughts of suicide or need for help around suicidality: 113 Zelfmoordpreventie",
      ],
      note: "For users outside the Netherlands: contact your local emergency services or a local crisis service.",
    },
    {
      heading: "Professional help",
      body: [
        "If you have questions about a medical or psychological condition, treatment or medication, contact a qualified healthcare professional.",
        "Inner Compass can offer additional support but does not replace this professional.",
      ],
    },
  ],
};
